package com.exura.pages.planCreator.components

import androidx.compose.runtime.*
import com.exura.components.snackbar.SnackbarMessage
import com.exura.features.plandefinition.domain.model.plan.PlanType
import com.exura.features.plandefinition.domain.model.series.BaseSeries
import com.exura.features.plandefinition.domain.model.series.SeriesType
import com.exura.ui.*
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import kotlinx.coroutines.channels.Channel
import org.jetbrains.compose.web.css.px

/**
 * Text-based plan view with three-panel layout:
 * - SeriesListPanel (left, fixed width)
 * - SeriesDetailsPanel (center, flexible) - now handles three states
 * - SeriesTypeSelectorPanel (right, expandable overlay)
 */
@Composable
internal fun TextPlanView(
    viewMode: ViewMode,
    planType: PlanType,
    flattenedItems: List<FlattenedItem>,
    selectedIndexedSeries: IndexedSeries?,
    onSeriesSelected: (IndexedSeries?) -> Unit,
    selectedSeriesTypeForCreation: SeriesType?,
    onSeriesTypeForCreationSelected: (SeriesType?) -> Unit,
    onSeriesSaved: (BaseSeries<*>) -> Unit,
    onSeriesAdded: (BaseSeries<*>) -> Unit,
    seriesGroupingMode: SeriesGroupingMode,
    onSeriesGroupingModeChange: (SeriesGroupingMode) -> Unit,
    snackbarEmitter: Channel<SnackbarMessage>
) {
    var isSeriesTypeSelectorExpanded by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(ExuraColors.WHITE)
            .overflow(Overflow.Auto)
    ) {
        Row(
            modifier = Modifier.fillMaxSize().overflow(Overflow.Auto)
        ) {
            // Left Panel - Series List (fixed width)
            SeriesListPanel(
                modifier = Modifier.width(320.px),
                viewMode = viewMode,
                flattenedItems = flattenedItems,
                selectedIndexedSeries = selectedIndexedSeries,
                onSeriesSelected = onSeriesSelected,
                seriesGroupingMode = seriesGroupingMode,
                onSeriesGroupingModeChange = onSeriesGroupingModeChange,
                onAddSeriesClick = {
                    isSeriesTypeSelectorExpanded = true
                }
            )

            // Center Panel - Series Details with three-state logic
            SeriesDetailsPanel(
                modifier = Modifier.fillMaxSize(),
                viewMode = viewMode,
                selectedIndexedSeries = selectedIndexedSeries,
                selectedSeriesTypeForCreation = selectedSeriesTypeForCreation,
                snackbarEmitter = snackbarEmitter,
                planType = planType,
                onSeriesSaved = onSeriesSaved,
                onSeriesAdded = onSeriesAdded,
            )
        }

        if (viewMode == ViewMode.EDIT) {
            SeriesTypeSelectorPanel(
                selectedSeriesType = selectedSeriesTypeForCreation,
                modifier = Modifier
                    .fillMaxHeight()
                    .align(Alignment.CenterEnd),
                onSeriesTypeSelected = { seriesTypeInfo ->
                    onSeriesTypeForCreationSelected(seriesTypeInfo.seriesType)
                    isSeriesTypeSelectorExpanded = false
                },
                onArrow = {
                    isSeriesTypeSelectorExpanded = !isSeriesTypeSelectorExpanded
                },
                isExpanded = isSeriesTypeSelectorExpanded,
            )
        }
    }
}
